import React from 'react';
import { Icon } from './Icon.js';
export const IconHeadphonesPlus = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.05565 14H8V21H3V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V21H16V14H20.9266", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9.5 8.5H14.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 6V11", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHeadphonesPlus.js.map